import { AVAILABLE_LANGUAGES, DEFAULT_LANGUAGE, ITEM_HEIGHT, } from "../constants";
const isAvailableLanguage = (x) => {
    const availableLanguages = Object.keys(AVAILABLE_LANGUAGES);
    return availableLanguages.includes(x);
};
const defaultRegionByLanguage = (language) => {
    var _a, _b, _c, _d;
    if (isAvailableLanguage(language)) {
        return language;
    }
    const availableLanguagesByLang = Object.keys(AVAILABLE_LANGUAGES).reduce((acc, lang) => {
        var _a, _b;
        const onlyLang = (_a = lang.split("-")) === null || _a === void 0 ? void 0 : _a[0];
        return Object.assign(Object.assign({}, acc), { [onlyLang]: [...((_b = acc === null || acc === void 0 ? void 0 : acc[onlyLang]) !== null && _b !== void 0 ? _b : []), lang] });
    }, {});
    const onlyLang = (_a = language.split("-")) === null || _a === void 0 ? void 0 : _a[0];
    return (_d = (_c = Object.values((_b = availableLanguagesByLang === null || availableLanguagesByLang === void 0 ? void 0 : availableLanguagesByLang[onlyLang]) !== null && _b !== void 0 ? _b : {})) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : DEFAULT_LANGUAGE;
};
export const getOrderedLanguages = (languages, rotated) => {
    const languagesSorted = languages.sort((languageA, languageB) => languageA.localeCompare(languageB));
    if (rotated) {
        return languagesSorted.reverse();
    }
    return languagesSorted;
};
export const getCleanLanguages = (languages) => languages.filter((language) => isAvailableLanguage(language));
export const getNormalizedCurrentLanguage = (language, availableLanguages) => {
    const currentLang = isAvailableLanguage(language) ? language : defaultRegionByLanguage(language);
    return availableLanguages.includes(currentLang) ? currentLang : DEFAULT_LANGUAGE;
};
export const getPositionConfig = (itemsCount, rotated) => {
    const maxVerticalTransform = ITEM_HEIGHT * (itemsCount > 6 ? 6 : itemsCount) + 8;
    return {
        top: {
            anchorOrigin: {
                vertical: rotated ? "top" : "bottom",
                horizontal: rotated ? "left" : "right",
            },
            transformOrigin: {
                vertical: rotated ? maxVerticalTransform : -8,
                horizontal: rotated ? "left" : "right",
            },
        },
        bottom: {
            anchorOrigin: {
                vertical: rotated ? "bottom" : "top",
                horizontal: rotated ? "left" : "right",
            },
            transformOrigin: {
                vertical: rotated ? -8 : maxVerticalTransform,
                horizontal: rotated ? "left" : "right",
            },
        },
    };
};
